<template>
  <qc-container  title="会员设置">
    <div class="flex" >
      <el-form ref="ruleForm" :model="detail" label-width="120px">
        <h3>注册新用户</h3>
        <el-form-item class="row" label="赠送" >
           <div class="flex-cc">
             <div>
               <t-button @click="openSendCoupon(0)">选择优惠券</t-button>
             </div>
             <el-tag class="mt10" @close="doDelete(0,index)" v-for="(item,index) in detail.registerList" closable >{{item.couponName}}</el-tag>
           </div>
        </el-form-item>
<!--        <h3>会员奖励</h3>
        <el-form-item class="row" label="升级要求" >
          <span class="mr10">会员消费满</span>
          <el-input-number  :controls="false" v-model.number="detail.memberMoney"/>
          <span class="ml10">元</span>
        </el-form-item>
        <el-form-item class="row" label="赠送" >
          <div class="flex-cc">
            <div>
              <t-button @click="openSendCoupon(1)">选择优惠券</t-button>
            </div>
            <el-tag class="mt10" @close="doDelete(1,index)" v-for="(item,index) in detail.memberList" closable >{{item.couponName}}</el-tag>
          </div>
        </el-form-item>-->
        <el-form-item class="tc mr50">
          <el-button class="f14 mr30 " type="primary" @click="submitForm()">保存</el-button>
        </el-form-item>
      </el-form>

      <send-discount ref="sendDiscount" @send="doSend"></send-discount>
    </div>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import TButton from "@/components/el/t-button.vue";
import SendDiscount from "@view/components/send-discount.vue";

export default {
  name: "set",
  components: {SendDiscount, TButton, QcContainer},
  data() {
    return {
      detail: {memberMoney:0,memberList:[],registerList:[]},
      type:0,
    }
  },
  mixins: [tableBase],
  methods: {
    doDelete(type,index){
      if(type===0){
        this.detail.registerList.splice(index,1);
      }else{
        this.detail.memberList.splice(index,1);
      }
    },
    doSend(list){
      if(this.type===0){
        list.forEach(row=>{
          let index = this.detail.registerList.findIndex(item=>item.couponId===row.id);
          if(index===-1){
            this.detail.registerList.push({couponId:row.id,couponName:row.name});
          }
        })
      }else{
        list.forEach(row=>{
          let index = this.detail.memberList.findIndex(item=>item.couponId===row.id);
          if(index===-1){
            this.detail.memberList.push({couponId:row.id,couponName:row.name});
          }
        })
      }
    },
    openSendCoupon(type){
      this.type = type;
      this.$refs.sendDiscount.show();
    },
    submitForm(){
      this.simplePost("/api/mgr/setting/saveMemberConfig",{contentType:_CONTENT_TYPE_JSON,...this.detail},result=>{
        this.message("修改成功");
      })
    }
  },
  mounted() {
    this.simplePost("/api/mgr/setting/getMemberConfig",null,res=>{
      this.detail = res.data;
    })
  }
}
</script>


<style lang="less" scoped>
</style>
